// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + ({"76":"common","530":"page","952":"burger"}[chunkId] || chunkId) + ".js";
};